import { PRODUCT } from '../../../services/property-status/property-status.service.models';
import type { Product } from '../../../services/property-status/property-status.service.models';

/** The design's column order, which is not the order `PRODUCT` declares them in. */
export const PRODUCT_COLUMNS: Product[] = [PRODUCT.HKA, PRODUCT.BKA, PRODUCT.UVI, PRODUCT.RWM, PRODUCT.HEAT_CONTROL];

/** Kept as one constant because AG Grid needs the pagination page size and the cache block size to agree. */
export const PROPERTY_OVERVIEW_PAGE_SIZE = 50;

/** What the last list request produced. Emptiness is derived from a zero total, so the two can never disagree. */
export type PropertyOverviewOutcome = { status: 'loaded'; total: number } | { status: 'failed'; denied: boolean };

/** What the grid hands its overlay; AG Grid merges its own `IOverlayParams` in on top of these. */
export interface PropertyOverviewOverlayInputs {
  outcome: PropertyOverviewOutcome;
  /** Selects the filtered wording, which names the product filter rather than claiming there is nothing at all. */
  filtered: boolean;
  retry: () => void;
}
